import css from 'styled-jsx/css';

const styles = css`.error-label{color:#ff2b2b;font-size:.75rem;line-height:1.125rem;text-align:left;display:block;padding-top:3px;padding-left:3px;line-height:1em}`;

export default styles;